import { computed, ref, toValue, watch } from "vue";
import { createApiClient } from "#/shared/api/client";
import { buildEventsOmnisearchItems } from "#ce/apps/SpEventsOmnisearch/events-quantum-items.js";

/**
 * Fetches the events autocomplete corpus once per `src` and maps it to
 * quantum-select items. Fetch errors are swallowed into an empty list
 * (legacy parity — the dropdown degrades silently).
 *
 * @param {import('vue').MaybeRefOrGetter<string|undefined>} src - the autocomplete payload URL
 */
export function useEventsOmnisearchData(src) {
  const api = createApiClient({ parse: false });
  const payload = ref(null);
  const loading = ref(true);

  async function fetchData() {
    const url = toValue(src);
    if (!url) {
      payload.value = null;
      loading.value = false;
      return;
    }
    loading.value = true;
    try {
      payload.value = await api.request("get", url);
    } catch {
      payload.value = null;
    } finally {
      loading.value = false;
    }
  }

  watch(() => toValue(src), fetchData, { immediate: true });

  const items = computed(() => buildEventsOmnisearchItems(payload.value));

  return {
    idleItems: computed(() => items.value.idleItems),
    searchItems: computed(() => items.value.searchItems),
    loading,
  };
}
